require('fslightbox')
